<div class="layout-topbar">
    <div class="btn-and-menu">

        <button #menubutton class="p-link layout-menu-button layout-topbar-button"
            (click)="layoutService.onMenuToggle()">
            <i class="pi pi-bars"></i>
        </button>

        <a class="layout-topbar-logo" routerLink="">
            <img src="./assets/AdminAI-color.png" alt="logo" />
            <!--   <img
            src="assets/images/{{
                layoutService.config.colorScheme === 'light'
                    ? 'logo-dark'
                    : 'logo-white'
            }}.png"
            alt="logo"
        /> -->
        </a>

    </div>
    <button #topbarmenubutton class="p-link layout-topbar-menu-button layout-topbar-button"
        (click)="layoutService.showProfileSidebar()">
        <i class="pi pi-ellipsis-v"></i>
    </button>

    <div #topbarmenu class="layout-topbar-menu" [ngClass]="{
            'layout-topbar-menu-mobile-active':
                layoutService.state.profileSidebarVisible
        }">
        <!-- <button class="p-link layout-topbar-button">
            <i class="pi pi-bell" pBadge value="2"></i>
            <span>Inbox</span>
        </button> -->
        <!-- estado real de la conexión de WhatsApp (AF327, WspStatusService). Conectado no hace nada al tocarlo -->
        @if (wspStatus.state() === 'connected') {
        <button type="button" class="btn-whatsapp connected" title="Tu WhatsApp está conectado">
            <img src="./assets/whatsapp-logo-connected.svg" alt="">
            Conectado
            <div class="circle"></div>
        </button>
        }
        @else if (wspStatus.state() !== 'none') {
        <button type="button" (click)="showWspDialog = true" class="btn-whatsapp disconnected">
            <img src="./assets/whatsapp-logo-disconnected.svg" alt="">
            Desconectado
            <div class="circle">
            </div>
        </button>
        }
        @if (isAdministration()) {
        <a routerLink="/message-packages" class="messages-btn"
            [class.empty]="messageBalanceStatus() === 'empty'" [class.low]="messageBalanceStatus() === 'low'"
            [title]="messagesTitle()">
            @if (messageBalanceStatus() === 'empty' || messageBalanceStatus() === 'low') {
            <i class="pi pi-exclamation-triangle"></i>
            } @else {
            <i class="pi pi-envelope"></i>
            }
            {{ availableMessagesText() }}
        </a>
        }
        <a routerLink="/chats" #menubutton class="chat-btn">
            <img src="./assets/chat-icon.svg" alt=""> Ir al chat
        </a>
        <div class="divider"></div>
        <button class="p-link layout-topbar-button" (click)="notificationsMenu.toggle($event)" #btnNot>
            <i class="pi pi-bell"></i>
            <span>Notificaciones</span>
            @if(showGreen) {

            <div class="greendot"></div>
            }
        </button>
        <p-tieredMenu #notificationsMenu [appendTo]="topbarmenu" [model]="notifications" [popup]="true">
        </p-tieredMenu>
        <button class="p-link layout-topbar-button" (click)="userMenu.toggle($event)">
            <i class="pi pi-user"></i>
            <span>Profile</span>
        </button>
        <p-tieredMenu #userMenu [appendTo]="topbarmenu" [model]="itemsMenu" [popup]="true"></p-tieredMenu>
    </div>
</div>
<!-- al tocar "Desconectado" (AF327): sin suscripción, cómo suscribirse; si no, por qué está desconectado y cómo contactar a Soporte -->
@if (showWspDialog) {
<div class="bk-limit">
    <div class="container-limit">
        @if (wspStatus.state() === 'no-subscription') {
            <h3>WhatsApp</h3>
            <p>Para conectar tu WhatsApp necesitás una suscripción activa.</p>
            <p><br><br></p>
            <div class="flex gap-2">
                <button class="button-primary" (click)="showWspDialog = false">Cerrar</button>
                <a class="button-primary" [routerLink]="['/subscription', currentUser?.parentUid]" [queryParams]="{email: currentUser?.email}" (click)="showWspDialog = false">Suscribirme</a>
            </div>
        } @else {
            <h3>Tu WhatsApp está desconectado</h3>
            <p>{{ wspStatus.reason() }}</p>
            @if (wspStatus.reason() !== wspDisconnectedText) {
                <p>Mientras tanto, AdminAI no puede recibir ni mandar mensajes. Comunicate con Soporte de AdminAI para conectarlo.</p>
            }
            <p><b>Soporte de AdminAI:</b> {{ supportDisplay }}</p>
            <p><br><br></p>
            <div class="flex gap-2">
                <button class="button-primary" (click)="showWspDialog = false">Cerrar</button>
                <a class="button-primary" [href]="supportLink" target="_blank" rel="noopener" (click)="showWspDialog = false">Escribir a Soporte</a>
            </div>
        }
    </div>
</div>
}
<p-toast></p-toast>
